module.exports = __webpack_public_path__ + "static/media/Mtechprg.29ee2f1e.pdf";